/**
 * Recursively normalizes two objects/arrays for deep comparison:
 * - Ensures both have the same set of keys (union of keys), filling missing keys with null
 * - Treats '', undefined as null
 * - Useful for dirty checks where missing/null/empty values should be considered equal
 */
export function normalizeAndFill(obj: unknown, reference: unknown): unknown {
  if (Array.isArray(obj) && Array.isArray(reference)) {
    // Normalize each element with corresponding reference element
    return obj.map((item, i) => normalizeAndFill(item, reference[i]));
  }

  if (obj && typeof obj === 'object' && reference && typeof reference === 'object') {
    const allKeys = new Set([...Object.keys(obj as object), ...Object.keys(reference as object)]);
    const result: Record<string, unknown> = {};

    for (const key of allKeys) {
      const v1 = (obj as Record<string, unknown>)[key];
      const v2 = (reference as Record<string, unknown>)[key];

      result[key] = normalizeAndFill(v1 === undefined ? null : v1, v2 === undefined ? null : v2);
    }

    return result;
  }

  // Treat '', undefined as null
  return obj === '' || obj === undefined ? null : obj;
}
